/**
 * Chuỗi của bộ cài và bàn giao bản on-premise (ADR-0092, ADR-0107): tab Bộ cài ở màn License, lịch sử bàn giao,
 * phiếu bàn giao, checklist khởi động và ngừng dùng bản cài ở tab License của tenant. Khoá cấp một `banGiao`, sâu tối
 * đa hai cấp dưới nó.
 */
export const viBanGiao = {
  banGiao: {
    tabBoCai: 'Bộ cài',

    // ── Kênh, loại, trạng thái ──
    kenh: {
      STABLE: 'STABLE',
      BETA: 'BETA',
    },
    trangThaiPhatHanh: {
      PROCESSING: 'Đang xử lý',
      FAILED: 'Phát hành thất bại',
    },
    kieu: {
      INSTALL: 'Cài mới',
      UPGRADE: 'Nâng cấp',
    },
    trangThai: {
      PREPARED: 'Đã chuẩn bị',
      DELIVERED: 'Đã giao, chờ khách',
      CUSTOMER_CONFIRMED: 'Khách đã xác nhận',
      FAILED: 'Thất bại',
      CANCELLED: 'Đã huỷ',
    },
    ketQua: {
      SUCCESS: 'Thành công',
      ROLLED_BACK: 'Đã quay lại bản cũ',
      FAILED: 'Thất bại',
    },
    topology: {
      K3S_SINGLE_NODE: 'K3s một node',
      COMPOSE_MINIMAL: 'Compose rút gọn',
    },

    // ── Tab Bộ cài ──
    locTatCa: 'Tất cả kênh',
    phatHanhMoi: 'Phát hành bản mới',
    boCaiCaption: 'Danh sách bản phát hành bộ cài on-premise',
    boCaiRong: 'Chưa có bản phát hành nào',
    boCaiRongMo: 'CI build xong sẽ ghi bộ cài vào vùng chờ; phát hành từ đó để bản mới vào kênh BETA.',
    boCaiRongLoc: 'Không có bản phát hành nào ở kênh này',
    cotPhienBan: 'Phiên bản',
    cotPhatHanh: 'Phát hành',
    dongKenh: 'Kênh',
    dongDungLuong: 'Dung lượng',
    xemChiTiet: 'Xem chi tiết',
    taoVeTaiBoCai: 'Tạo liên kết tải bộ cài',
    duaLenStable: 'Đưa lên STABLE',
    thuHoiBan: 'Thu hồi bản phát hành',

    chiTietTieuDe: 'Bản phát hành {{version}}',
    dongTepBoCai: 'Tệp bộ cài',
    dongSha: 'SHA-256 bộ cài',
    chuaRoDungLuong: 'Chưa rõ',
    dongNenTang: 'Nền tảng',
    dongTopology: 'Mô hình triển khai',
    dongNangTu: 'Nâng thẳng từ bản',
    khongGioiHanNangTu: 'Không giới hạn',
    dongKeyring: 'Keyring sequence',
    dongPhatHanhLuc: 'Phát hành lúc',
    dongManifest: 'Manifest (JWS)',
    chepManifest: 'Sao chép manifest',
    thanhPhanTieuDe: 'Thành phần',
    thanhPhanCaption: 'Image trong bộ cài {{version}}, ghim theo digest',
    thanhPhanRong: 'Manifest không liệt kê thành phần nào',
    cotThanhPhan: 'Thành phần',
    cotImage: 'Image và digest',

    phatHanhTieuDe: 'Phát hành bộ cài mới',
    phatHanhMo:
      'CI đã ghi tệp bộ cài và release.json vào vùng chờ platform/installers/incoming/. Hệ thống xử lý ở nền: chuyển tệp vào kho chính thức, băm SHA-256, ký manifest rồi đưa bản mới vào kênh BETA. Bộ cài vài GB mất vài phút; đóng hộp này cũng không sao. Tệp không đi qua trình duyệt.',
    oThuMuc: 'Thư mục trong vùng chờ',
    oThuMucGoiY: 'Tên thư mục CI in ra cuối bước build, dạng <product_code>-<version>.',
    oThuMucViDu: 'platform-enterprise-2.5.0',
    nhanPhatHanh: 'Phát hành vào BETA',
    dangPhatHanh: 'Đang phát hành...',
    loiThieuThuMuc: 'Nhập tên thư mục CI in ra.',
    loiThuMucSai: 'Tên thư mục chỉ gồm chữ, số, dấu chấm, gạch dưới, gạch ngang và không bắt đầu bằng dấu chấm hay gạch ngang.',
    daPhatHanh: 'Đã nhận bản {{version}}. Hệ thống đang xử lý ở nền, bảng tự cập nhật khi xong.',
    dangXuLyPhanTram: 'Đang xử lý {{phanTram}}%',
    phatHanhLai: 'Phát hành lại',
    dongLyDoThatBai: 'Lý do thất bại',
    coSauKhiXong: 'Có sau khi phát hành xong',

    duaLenTieuDe: 'Đưa bản {{version}} lên STABLE?',
    duaLenThan:
      'Bản STABLE dùng được để tạo bàn giao cho khách. Chỉ đưa lên khi đã thử xong nội bộ. Không đưa ngược về BETA được.',
    nhanDuaLen: 'Đưa {{version}} lên STABLE',
    daDuaLenStable: 'Đã đưa bản {{version}} lên STABLE.',

    thuHoiBanTieuDe: 'Thu hồi bản phát hành {{version}}?',
    thuHoiBanThan:
      'Bản bị thu hồi biến khỏi danh sách, không tạo được liên kết tải hay bàn giao mới. Bàn giao đã tạo giữ nguyên; tệp và manifest giữ lại để truy vết. Không hoàn tác được.',
    lyDoThuHoiBan: 'Lý do thu hồi',
    lyDoThuHoiBanViDu: 'Ví dụ: migration khoá bảng audit quá lâu trên dữ liệu lớn.',
    loiThieuLyDoThuHoiBan: 'Nhập lý do thu hồi để người sau biết vì sao bản này bị gỡ.',
    nhanThuHoiBan: 'Thu hồi bản {{version}}',
    daThuHoiBan: 'Đã thu hồi bản {{version}}.',

    // ── Liên kết tải ──
    veBoCaiTieuDe: 'Liên kết tải bộ cài {{version}}',
    veBanGiaoTieuDe: 'Liên kết tải bộ bàn giao {{version}}',
    veThan: 'Liên kết dùng được một lần và hết hạn lúc {{luc}} (sau 10 phút). Hết hạn hay đã dùng thì tạo liên kết mới.',
    veCanhBao: 'Tải không cần đăng nhập: ai có liên kết cũng tải được, nên chỉ gửi cho đúng người nhận.',
    moLienKet: 'Tải xuống',
    chepLienKet: 'Sao chép liên kết tải',
    saoChep: 'Sao chép',
    daChep: 'Đã chép',
    khongChepDuoc: 'Trình duyệt không cho chép tự động. Chọn đoạn chữ rồi chép bằng tay.',

    // ── Lịch sử bàn giao ──
    lichSuTieuDe: 'Lịch sử bàn giao',
    lichSuMo: 'Bộ bàn giao đã chuẩn bị cho tenant này và kết quả khách gửi lại',
    lichSuCaption: 'Lịch sử bàn giao bản on-premise của {{ten}}',
    lichSuRong: 'Chưa bàn giao bản nào',
    lichSuRongMo: 'Tạo bàn giao từ một bản STABLE để có bộ bàn giao và phiếu bàn giao gửi khách.',
    cotNgayTao: 'Ngày tạo',
    dongLoai: 'Loại',
    chuaGanCaiDat: 'Chưa gắn bản cài',
    theoXacNhan: 'Theo xác nhận của khách ngày {{ngay}}',
    theoBaoCaoThatBai: 'Theo báo cáo của khách ngày {{ngay}}',
    xemPhieu: 'Xem phiếu bàn giao',
    taiBoBanGiao: 'Tạo liên kết tải bộ bàn giao',
    danhDauDaGiao: 'Đánh dấu đã giao',
    ghiKetQua: 'Ghi kết quả nâng cấp',
    huyBanGiao: 'Huỷ bàn giao',

    taoBanGiao: 'Tạo bàn giao',
    taoBanGiaoNangCap: 'Tạo bàn giao nâng cấp',
    taoTieuDe: 'Tạo bàn giao bản on-premise',
    taoMo: 'Hệ thống sinh bộ bàn giao riêng cho tenant này (kho tin cậy, mẫu cấu hình, hướng dẫn). Bộ bàn giao không chứa license hay secret.',
    kieuInstallMo: 'Khách cài lần đầu. Tự sang "Khách đã xác nhận" khi nhận activation-request.json đúng phiên bản.',
    kieuUpgradeMo: 'Nâng một bản cài đang chạy. Xác nhận bằng upgrade-report.json khách gửi lại.',
    chonCaiDat: 'Chọn bản cài cần nâng cấp',
    nhanCaiDat: '{{ten}} · đang chạy {{version}}',
    chuaCoCaiDat: 'Tenant chưa có bản cài nào nhận được bàn giao. Bản cài xuất hiện sau khi khách gửi activation-request.json.',
    chuaRoDangChay:
      'Chưa rõ phiên bản đang chạy của bản cài này. Vẫn tạo được; foxai-install upgrade sẽ kiểm phiên bản tại máy khách.',
    oBanPhatHanh: 'Bản phát hành',
    chonBan: 'Chọn bản STABLE',
    nhanBan: '{{version}} · {{san_pham}} · {{ngay}}',
    dangTaiBan: 'Đang tải danh sách bản phát hành...',
    chiStable: 'Chỉ bản STABLE chưa thu hồi mới bàn giao được.',
    chuaCoStable: 'Chưa có bản STABLE nào. Đưa một bản BETA đã thử lên STABLE ở tab Bộ cài của màn License.',
    khongCoBanNangCap: 'Không có bản STABLE nào mới hơn bản đang chạy mà nâng thẳng được từ bản đó.',
    ghiChuTaoGoiY: 'Không bắt buộc. Ví dụ: số hợp đồng, người nhận dự kiến.',
    loiChuaChonCaiDat: 'Chọn bản cài cần nâng cấp.',
    loiChuaChonBan: 'Chọn một bản STABLE.',
    dangTao: 'Đang tạo...',
    daTao: 'Đã tạo bàn giao bản {{version}}.',

    phieuDialogTieuDe: 'Phiếu bàn giao bản {{version}}',
    dongShaBoBanGiao: 'SHA-256 bộ bàn giao',
    dongBangChung: 'SHA-256 bằng chứng',
    dongGhiChu: 'Ghi chú',
    dongTaoLuc: 'Tạo lúc',

    giaoTieuDe: 'Đánh dấu đã giao bản {{version}}?',
    giaoThan: 'Ghi nhận bộ bàn giao đã tới khách. Lần bàn giao chuyển sang "Đã giao, chờ khách".',
    oKenhGiao: 'Kênh giao và người nhận',
    oKenhGiaoGoiY: 'Không bắt buộc. Ví dụ: gửi link qua email cho anh Huy, phòng CNTT.',
    daDanhDauGiao: 'Đã đánh dấu đã giao.',

    ghiTieuDe: 'Ghi kết quả nâng cấp lên {{version}}',
    ghiThan:
      'Tải lên upgrade-report.json do foxai-install upgrade ghi ở máy khách. Báo cáo không ký số: hệ thống ghi đây là xác nhận của khách, không phải bằng chứng đã cài thành công.',
    tepBaoCao: 'Tệp upgrade-report.json',
    baoCaoKeoTha: 'Kéo thả upgrade-report.json vào đây, hoặc bấm để chọn tệp',
    baoCaoKeoThaMo: 'Tệp JSON, tối đa 64 KB.',
    dongKetQua: 'Kết quả',
    dongNangCap: 'Nâng cấp',
    tuDen: '{{tu}} → {{den}}',
    dongXongLuc: 'Xong lúc',
    ghiHauQuaThanhCong: 'Lần bàn giao sẽ chuyển sang "Khách đã xác nhận" và bản cài được tính là đang chạy phiên bản này.',
    ghiHauQuaThatBai:
      'Lần bàn giao sẽ chuyển sang "Thất bại". Đây là trạng thái cuối: giao lại thì tạo bàn giao mới.',
    ghiChuGoiY: 'Không bắt buộc. Ví dụ: người gửi báo cáo, kênh nhận.',
    dangGhi: 'Đang ghi...',
    loiBaoCaoJson: 'Tệp không phải JSON hợp lệ. Chọn đúng tệp upgrade-report.json do foxai-install sinh ra.',
    loiBaoCaoDoiTuong: 'Tệp phải là một đối tượng JSON. Chọn đúng tệp upgrade-report.json do foxai-install sinh ra.',
    loiBaoCaoThieu: 'Báo cáo thiếu trường {{truong}}. Chọn đúng tệp upgrade-report.json do foxai-install sinh ra.',
    loiBaoCaoKetQua: 'Trường result phải là SUCCESS, ROLLED_BACK hoặc FAILED. Kiểm lại tệp khách gửi.',
    loiBaoCaoLech:
      'Trường {{truong}} của báo cáo không khớp lần bàn giao này. Có thể khách gửi báo cáo của lần nâng cấp khác; hỏi lại khách.',
    loiBaoCaoLon: 'Tệp lớn hơn 64 KB, không phải upgrade-report.json. Chọn lại tệp.',
    loiBaoCaoChuaChon: 'Chọn tệp upgrade-report.json để tiếp tục.',
    daGhiThanhCong: 'Đã ghi: khách xác nhận nâng cấp lên {{version}}.',
    daGhiThatBai: 'Đã ghi: nâng cấp lên {{version}} thất bại. Tạo bàn giao mới khi sẵn sàng giao lại.',

    huyTieuDe: 'Huỷ lần bàn giao bản {{version}}?',
    huyThan:
      'Lần bàn giao chuyển sang "Đã huỷ", không giao hay ghi kết quả được nữa. Bộ bàn giao đã gửi khách không tự mất hiệu lực: báo khách không dùng. Không hoàn tác được.',
    lyDoHuy: 'Lý do huỷ',
    lyDoHuyViDu: 'Ví dụ: bản phát hành bị thu hồi trước khi giao.',
    loiThieuLyDoHuy: 'Nhập lý do huỷ để người sau biết vì sao lần bàn giao dừng lại.',
    daHuy: 'Đã huỷ lần bàn giao.',

    // ── Phiếu bàn giao (ADR-0094 mục 2.2) ──
    phieuTieuDe: 'Phiếu bàn giao',
    phieuKenhThuHai:
      'Gửi hai giá trị dưới đây qua kênh thứ hai, tách khỏi đường giao tệp: email từ đầu mối hợp đồng hoặc bản in. Không gửi kèm liên kết tải hay cùng gói bộ bàn giao.',
    phieuSha: 'SHA-256 bộ cài {{version}}',
    phieuVanTay: 'Dấu vân tay khoá gốc',
    phieuVanTaySo: 'Dấu vân tay khoá gốc {{so}}',
    phieuCachDoiChieu:
      'Quản trị viên khách chạy sha256sum với tệp bộ cài và đối chiếu trước khi giải nén; foxai-install verify in dấu vân tay khoá gốc để đối chiếu lần nữa.',
    chepSha: 'Sao chép SHA-256 bộ cài',
    chepVanTay: 'Sao chép dấu vân tay khoá gốc {{so}}',

    // ── Bản cài ──
    cotDangChay: 'Phiên bản đang chạy',
    chuaRo: 'Chưa rõ',
    ngungDung: 'Ngừng dùng',
    ngungTieuDe: 'Ngừng dùng bản cài {{ten}}?',
    ngungThan:
      'Bản cài chuyển sang "Đã ngừng", không nhận yêu cầu license hay bàn giao mới. License của bản cài phải được thu hồi trước: còn license hiệu lực thì hệ thống từ chối. Không hoàn tác được.',
    lyDoNgung: 'Lý do ngừng dùng',
    lyDoNgungViDu: 'Ví dụ: khách chuyển sang cụm máy chủ mới ở Thủ Đức.',
    loiThieuLyDoNgung: 'Nhập lý do ngừng dùng bản cài.',
    nhanNgung: 'Ngừng dùng bản cài',
    daNgungCaiDat: 'Đã ngừng dùng bản cài {{ten}}.',

    // ── Checklist khởi động ──
    checklistTieuDe: 'Đưa tenant on-premise vào dùng',
    checklistMo: 'Xong {{xong}}/{{tong}} bước',
    buocSo: 'Bước {{so}}. {{ten}}',
    buoc1: 'Tạo bàn giao',
    buoc1Mo: 'Chọn một bản STABLE; hệ thống sinh bộ bàn giao và phiếu bàn giao để gửi khách.',
    buoc2: 'Nhận activation-request.json',
    buoc2Mo: 'Khách cài xong, bộ cài sinh activation-request.json. Bước này xong khi bản cài đầu tiên được đăng ký.',
    buoc3: 'Cấp license',
    buoc3Mo: 'Nạp activation-request.json ở trình cấp license rồi ký license cho bản cài đó.',
    daXong: 'đã xong',
    chuaXong: 'chưa xong',
  },
};
